module.exports = __webpack_public_path__ + "dingbeauty-landing/img/plan03@2.519a5f91.jpg";